import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import CssBaseline from "@mui/material/CssBaseline";
import MainLayout from "../../components/layout/MainLayout";
import PolicyPage from "../../components/policy-page";
import useGetPolicyPage from "../../api-manage/hooks/react-query/useGetPolicyPage";
import SEO from "../../components/seo";
import useConfigData from "../../hooks/useConfigData";

const Index = () => {
  const { configData, landingPageData, loading } = useConfigData();
  const { t } = useTranslation();
  const { data, refetch, isFetching } = useGetPolicyPage("/terms-and-conditions");

  useEffect(() => {
    refetch();
  }, []);

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '18px'
      }}>
        Loading...
      </div>
    );
  }

  return (
    <>
      <CssBaseline />
      <SEO
        title={configData ? `Terms And Conditions` : "Loading..."}
        image={`${configData?.base_urls?.business_logo_url}/${configData?.fav_icon}`}
        businessName={configData?.business_name}
      />
      <MainLayout configData={configData} landingPageData={landingPageData}>
        <PolicyPage
          data={data}
          title={t("Terms And Conditions")}
          isFetching={isFetching}
        />
      </MainLayout>
    </>
  );
};

export default Index;
